export const SEARCH_QUERY_PARAM = 'search'

export const ENVIRONMENT = {
    prod: 'prod',
    test: 'test',
    acc: 'acc',
    migr: 'migr',
}

export const LOCALE_COOKIE_NAME = 'stopen-locale'
export const LOCALE_HEADER = 'x-locale'
